module.exports = __webpack_public_path__ + "img/game.03771020.svg";